jQuery(document).ready(function ($) {
    var $form = $('form.variations_form');

    // Create custom dropdowns from native selects.
    function createCustomDropDownFromNativeSelect() {
        $('form.variations_form select[name^="attribute_"]:not(.mock)').each(function () {
            var $select = $(this);
            $select.hide();
            var id = $select.attr('id');
            var name = $select.attr('name');
            var $label = $('label[for="' + id + '"]').text();

            // Use the default selected option's text if available.
            var $defaultSelectedOption = $select.find('option[selected="selected"]');
            if ($defaultSelectedOption.length) {
                $label = $defaultSelectedOption.text();
            }

            var $dropdown = $('<div class="custom-dropdown" name="attribute_' + id + '"></div>');
            var $selected = $('<div class="selected" data-value="' + $defaultSelectedOption.val() + '">' + ($label || 'Select an option') + '</div>');
            var $options = $('<ul class="options"></ul>');

            $select.find('option').each(function () {
                if ($(this).val() === '') {
                    return;
                }
                var $li = $('<li data-value="' + $(this).val() + '">' + $(this).text() + '</li>');
                $options.append($li);
            });

            $dropdown.append($selected).append($options);
            $select.after($dropdown);

            $selected.on('click', function (e) {
                e.stopPropagation();
                $dropdown.toggleClass('open');
            });

            $options.on('click', 'li', function () {
                var value = $(this).data('value');
                var text = $(this).text();
                $selected.text(text);
                $selected.attr('data-value', value);
                // Programmatically change native select value.
                $select.find('option').removeAttr('selected');
                $select.find('option[value="' + value + '"]').attr('selected', 'selected');
                $select.val(value).trigger('change');

                $dropdown.removeClass('open');
            });

            $(document).on('click', function () {
                $dropdown.removeClass('open');
            });
        });
    }

    function matchNativeSelectWithCustomSelect() {
        $(document).on('change', '.pa-battery-size-options input', function () {
            var radio = $(this);
            var radioName = radio.attr('name');
            var radioValue = radio.attr('value');
            $('select[name="' + radioName + '"] option').removeAttr('selected');
            $('select[name="' + radioName + '"]').val(radioValue).trigger('change');
            $('select[name="' + radioName + '"] option[value="' + radioValue + '"]').attr('selected', 'selected');

        });
    }

    function updateCustomOptions() {
        $('.custom-dropdown[name="attribute_pa_package-quantity"]').each(function () {
            var $dropdown = $(this);
            var dropdownName = $dropdown.attr('name'); // e.g., "attribute_<select ID>"
            var $optionsUl = $dropdown.find('.options');
            $optionsUl.empty();

            $('form.variations_form select[name^="' + dropdownName + '"]').find('option').each(function () {
                if ($(this).val() === '') {
                    return;
                }
                var $li = $('<li data-value="' + $(this).val() + '">' + $(this).text() + '</li>');
                // Append to the options only within this custom-dropdown.
                $dropdown.find('.options').append($li);
            });
        });
    }

    function initVariationMatcher() {
        let isResetting = false;
        const variations = $form.data('product_variations') || [];

        const variationMap = variations.reduce((map, variation) => {
            const key = Object.entries(variation.attributes)
                .map(([attr, val]) => `${attr}=${val}`)
                .sort()
                .join('|');
            map[key] = variation;
            return map;
        }, {});

        function getSelections() {
            return $form.find('select[name^="attribute_"]').toArray().reduce((sel, el) => {
                if (el.value === '' || el.value === undefined) {
                    sel[el.name] = $('.custom-dropdown[name="' + el.name + '"]').find('.selected').attr('data-value');
                    if (sel[el.name] === undefined) {
                        const val = $('input[name="' + el.name + '"]:checked').val();
                        sel[el.name] = val
                    }
                } else {
                    sel[el.name] = el.value;
                }
                return sel;
            }, {});
        }

        function hasValidVariation(selections) {
            return variations.some(variation =>
                Object.entries(variation.attributes).every(([attr, val]) =>
                    !selections[attr] || selections[attr] === val
                )
            );
        }

        function getFallbackAttributes(changedAttr, changedVal) {
            return variations.find(it => it.attributes[changedAttr] === changedVal)?.attributes || {};
        }

        function applyAttributes(attrs) {
            // build a processing order: quantity first, then everything else
            const priority = ['attribute_pa_package-quantity'];
            const allKeys = Object.keys(attrs);
            const ordered = [
                ...priority.filter(k => allKeys.includes(k)),
                ...allKeys.filter(k => !priority.includes(k))
            ];

            ordered.forEach(attrName => {
                const attrValue = attrs[attrName];
                const $select = $form.find(`select[name="${attrName}"]`);
                if (!$select.length) return;

                const attempt = () => {
                    const idx = $select.find(`option[value="${attrValue}"]`).index();
                    if (idx === -1) {
                        return setTimeout(attempt, 50);
                    }

                    $select.prop('selectedIndex', idx).val(attrValue).trigger('change');

                    const $custom = $(`.custom-dropdown[name="${attrName}"]`);
                    $custom
                        .attr('data-value', attrValue)
                        .find('.selected').text($select.find(`option[value="${attrValue}"]`).text());
                };
                attempt();
            });
        }


        function debounce(fn, wait) {
            let timeout;
            return function (...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => fn.apply(this, args), wait);
            };
        }

        const onChange = debounce(function (event) {
            if (isResetting) return;

            const $changed = $(event.target);
            const name = $changed.attr('name');
            var value = $changed.val();
            if (value === '' || value === null) {
                value = $('.custom-dropdown[name="' + name + '"]').find('.selected').attr('data-value');
                if (value === '' || value === undefined) {
                    value = $('input[name="' + name + '"]:checked').val();
                }
            } else {
                value = $changed.val();
            }


            const selections = getSelections();

            // If there’s already a valid variation for the current combo, do nothing.
            if (hasValidVariation(selections)) return;

            // otherwise, we need to reset the other dropdowns to a matching variation
            isResetting = true;

            const fallback = getFallbackAttributes(name, value);
            applyAttributes(fallback);

            isResetting = false;
        }, 200);

        $form
            .off('change.variationMatcher')
            .on('change.variationMatcher', 'select[name^="attribute_"]', onChange);
    }

    function resetVariations() {
        $('.reset_variations').on('click', function () {
            $('.custom-dropdown').each(function () {
                var $dropdown = $(this);
                $dropdown.find('.options').empty();
                var dropdownName = $dropdown.attr('name'); // e.g., "attribute_<id>"
                // Remove the "attribute_" prefix for the label lookup.
                var labelId = dropdownName.replace('attribute_', '');
                var $label = $('label[for="' + labelId + '"]').text();
                $dropdown.find('.selected').text($label);
            });

            $('.pa-battery-size-options input[type="radio"]').prop('checked', false);
        });
    }

    function deeplinkVariations() {
        if (document.body.classList.contains('single-product')) {
            const queryParams = new URLSearchParams(window.location.search);
            const id = queryParams.get('id');
            if ($('body').hasClass('single-product')) {
                const urlParams = new URLSearchParams(window.location.search);
                const variationId = urlParams.get('id');
                if (variationId) {
                    if ($form.length) {
                        const variations = $form.data('product_variations');
                        if (variations) {
                            let targetVariation = null;

                            $.each(variations, function (index, variation) {
                                if (variation.variation_id === Number(variationId)) {
                                    targetVariation = variation;
                                    return false; // Exit the loop once found
                                }
                            });

                            if (targetVariation) {
                                $.each(targetVariation.attributes, function (attributeName, attributeValue) {
                                    $form.find('select[name="' + attributeName + '"]').val(attributeValue).trigger('change');
                                    $form.find('.custom-dropdown[name="' + attributeName + '"]').find('.selected').text(attributeValue);
                                });
                            } else {
                                console.log("Variation with id " + variationId + " not found.");
                            }
                        }
                    }
                }
            }
        }
    }


    // Initialize
    setTimeout(function () {
        createCustomDropDownFromNativeSelect();
        deeplinkVariations();

    }, 500);
    matchNativeSelectWithCustomSelect();
    initVariationMatcher();

    $('form.variations_form select[name^="attribute_"]').on('change.updateOptions', function () {
        setTimeout(function () {
            updateCustomOptions();
        }, 500);
    });
});
